import {combineReducers} from 'redux';
import SchedulerCommonReducer from './schedulerCommonSlice';

const reducer = combineReducers({
	schedulerCommon: SchedulerCommonReducer
});

export default reducer;
